/* eslint-disable @typescript-eslint/no-explicit-any */ import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { createLocalizationProviderLanguageValidator } from "../localizationProviders/SWBaseLocalizationProviderLanguage";
/** @internal */ export const rootLocalizationProviderLanguageVersions = {};
/** @internal */ export const rootLocalizationProviderLanguageMigrations = defineMigrations({});
/** @public */ export function isLocalizationProviderLanguage(record) {
    if (!record) return false;
    return record.typeName === "localization_provider_language";
}
/** @public */ export function isLocalizationProviderLanguageId(id) {
    if (!id) return false;
    return id.startsWith("localization_provider_language:");
}
/** @public */ export function createLocalizationProviderLanguageId({ type, projectIdentifier, organizationId, locale }) {
    return `localization_provider_language:${[
        type,
        organizationId,
        projectIdentifier,
        locale
    ].join(":")}`;
}
// /** @public */
// export function parseLocalizationProviderLanguageId(id?: string) {
//   if (!id) return undefined
//   if (!id.startsWith("localization_provider_language:")) return undefined
//   // Split into many pieces
//   const parts = id.replace("localization_provider_language:", "").split(":")
//   const internalLocalizationProviderLanguageId = parseInt(parts[0], 10)
//   return {
//     internalLocalizationProviderLanguageId,
//   }
// }
/** @internal */ export function createLocalizationProviderLanguageRecordType(localization_provider_languages) {
    return createRecordType("localization_provider_language", {
        migrations: defineMigrations({
            subTypeKey: "type",
            subTypeMigrations: mapObjectMapValues(localization_provider_languages, (_, v)=>v.migrations ?? defineMigrations({}))
        }),
        scope: "presence",
        validator: T.model("localization_provider_language", T.union("type", mapObjectMapValues(localization_provider_languages, (type, { props, meta })=>createLocalizationProviderLanguageValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {},
            internalLocalizationProviderLanguageId: 0,
            visibilitySince: 0
        }));
}
